import { addDays, addMonths, addWeeks, addYears, format } from "date-fns";

export function getNextOccurrences(task, count = 5) {
    const repetition = task?.repetition;
    if (!repetition || repetition === "none") return [];

    const base = task.start_date
        ? new Date(task.start_date)
        : task.due_date
          ? new Date(task.due_date)
          : new Date();

    if (Number.isNaN(base.getTime())) return [];

    const stepFns = {
        daily: (d) => addDays(d, 1),
        weekly: (d) => addWeeks(d, 1),
        monthly: (d) => addMonths(d, 1),
        annually: (d) => addYears(d, 1),
        custom: (d) => addDays(d, 1),
    };

    const step = stepFns[repetition];
    if (!step) return [];

    const results = [];
    let cursor = new Date(base);

    for (let i = 0; i < count; i++) {
        cursor = i === 0 ? cursor : step(cursor);
        const label = format(cursor, "EEE, d MMM yyyy");
        const timeSuffix = task.start_time ? ` at ${task.start_time}` : "";
        results.push({ date: new Date(cursor), label: `${label}${timeSuffix}` });
    }

    return results;
}
